export default {
  SOUND: 'SOUND',
  COSTUME: 'COSTUME',
  SPRITE: 'SPRITE',
  CODE: 'CODE',

  BACKPACK_SOUND: 'BACKPACK_SOUND',
  BACKPACK_COSTUME: 'BACKPACK_COSTUME',
  BACKPACK_SPRITE: 'BACKPACK_SPRITE',
  BACKPACK_CODE: 'BACKPACK_CODE'
};
